import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import routes from '../../routes';
import {Router, applyRouterMiddleware} from 'react-router';
import useScroll from 'react-router-scroll/lib/useScroll';

const scrollBehaviour = (prevRouterProps, {location}) => !(location.state && location.state.scroll === false);

function Root({store, history}) {
  return (
    <Provider store={store}>
      <Router
        history={history}
        routes={routes}
        render={process.env.CLIENT ? applyRouterMiddleware(useScroll(scrollBehaviour)) : undefined}
      />
    </Provider>
  );
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./containers/root/Root.js